module.exports = __webpack_public_path__ + "static/favicon-f9b4407163921e4c92bc976ab35aa772.ico";